<template>
  <div class="main">
    <Nav ref="nav" v-if="clientWidth < 1200"></Nav>
    <div class="head">
      <div class="head-img">
        <div class="txtwav slow head-title">
          <span class="head-span">至</span>
          <span class="head-span">诚</span>
          <span class="head-span">关</span>
          <span class="head-span">爱</span>
        </div>
        <div class="txtwav slow head-text">
          <span class="head-span">和</span>
          <span class="head-span">谐</span>
          <span class="head-span">共</span>
          <span class="head-span">融</span>
        </div>
        <div class="head-right">
          <div class="head-right-weather" @click="goWeatcher">{{ weather }}</div>
          <div class="head-right-seek">
            <div @click="onSeek">
              <img src="../../assets/seek-icon.png" class="head-right-icon" />
            </div>
            <input
              v-model="keyword"
              placeholder="搜索想要的内容"
              class="head-right-input"
              @keyup.enter="onSeek"
            />
          </div>
        </div>
      </div>
    </div>
    <Menu></Menu>
    <div class="middle">
      <keep-alive>
        <router-view class="center" />
      </keep-alive>
      <div class="footer">
        <div class="footer-conten">
          <span>地址：{{ infoList.address }}</span>
          <span class="footer-iphone">电话：{{ infoList.phone }}</span>
        </div>
        <div class="footer-filing" @click="goLink()">
            {{ infoList.detail }}
        </div>
      </div>
      <WxIcon
        v-if="infoList.wechatOfficialAccountsUrl"
        :wcIcon="infoList.wechatOfficialAccountsUrl[0]"
      ></WxIcon>
    </div>
  </div>
</template>

<script>
import Nav from "../../components/Nav";
import Menu from "../../components/Menu/Menu-3";
import WxIcon from "../../components/WxIcon";

export default {
  data() {
    return {
      infoList: {},
      weather: "",
      keyword: ""
    };
  },
  computed: {
    clientWidth() {
      return document.body.clientWidth;
    }
  },
  components: {
    Nav,
    Menu,
    WxIcon
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.getWeather();
  },
  methods: {
    getInfo() {
      this.$http.get("/setting/open").then(res => {
        this.infoList = res.data.data[0];
      });
    },
    getWeather() {
      this.$http
        .get(`https://www.mxnzp.com/api/weather/current/深圳市`)
        .then(res => {
          this.weather = res.data.data.weather + "，" + res.data.data.temp;
        });
    },
    goLink() {
      window.location.href = "http://www.beian.miit.gov.cn";
    },
    goWeatcher() {
      if (document.body.clientHeight > 700) {
        window.location.href = "http://weather.sz.gov.cn/?s=1";
      } else {
        window.location.href =
          "http://weather.sz.gov.cn/mobile/qixiangfuwu/yujingyubao/yubaofuwu/weilaishitiantianqi/?from=singlemessage&isappinstalled=0";
      }
    },
    showMenu() {
      if (this.$refs.nav.isShow === false) {
        this.$refs.nav.showNav();
      } else {
        this.$refs.nav.closeNav();
      }
    },
    onSeek() {
      if (this.keyword) {
        this.$router.push({
          name: "searchList",
          query: { keyword: this.keyword }
        });
        this.keyword = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/font.css";
@import "../../styles/txt.wav.css";

.main {
  height: 100%;
  background: #fff0e6;
  min-width: 1200px;
}
.middle {
  position: relative;
  min-height: 76.5vh;
}
.center {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 20px;
  padding-bottom: 116px;
}
.head {
  margin: 0 auto;
  height: 154px;
  background-color: #ff8022;
  text-align: left;
  &-img {
    position: relative;
    background-image: url("../../assets/header.png");
    background-size: 100% 100%;
    height: 144px;
    width: 1200px;
    margin: 0 auto;
  }
  &-title {
    font-family: LWS;
    padding-top: 25px;
    font-size: 35px;
    font-weight: bold;
    color: #2682ff;
    margin-left: 710px;
  }
  &-text {
    @extend .head-title;
    padding: 0;
    margin-left: 750px;
  }
  &-span {
    margin-left: 5px;
  }
  &-right {
    position: absolute;
    right: 0;
    top: 40px;
    height: 64px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &-weather {
      height: 28px;
      line-height: 28px;
      border: 1px solid #fff;
      border-radius: 16px;
      width: 190px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }
    &-seek {
      @extend .head-right-weather;
      background: #fff;
      color: #939599;
      display: flex;
      align-content: center;
      justify-content: center;
    }
    &-icon {
      margin: 2px 8px 0 0;
      width: 20px;
      height: 19px;
    }
    &-input {
      width: 60%;
      border: none;
      font-size: 14px;
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ff8022;
  color: white;
  height: 100px;
  text-align: center;
  padding: 20px 0;
  font-size: 16px;
  font-weight: 400;
  &-filing {
    margin-top: 20px;
    cursor: pointer;
  }
  &-iphone {
    display: inline-block;
    margin-left: 24px;
  }
}
.nav {
  z-index: 200;
  align-items: center;
  position: fixed;
  top: 50px;
  right: 30px;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 3px;
  box-shadow: 0px 0px 3px 0px #cdcdcd;
  &-icon {
    width: 28px;
    height: 30px;
  }
}
</style>
